import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Ownership } from "../../models/ownership";

@Component({
  selector: "layer-header",
  templateUrl: "./layer-header.component.html",
  providers: [],
  styles: [],
})
export class LayerHeaderComponent {

  @Input() public listIcons: boolean = true;
  @Input() public listToggle: boolean = true;
  @Input() public title: string;
  @Input() public ownership: Ownership;
  @Input() public customClass: string = "mt-4";
  @Output() public closeLayer = new EventEmitter();
  @Output() public setListView = new EventEmitter();

  public setList(flag) {
    this.setListView.emit(flag);
  }

  public close() {
    this.closeLayer.emit(true);
  }

}
